/*
 * Copyright (c) 2024 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, June 7th 2024, 9:39:24 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Stack from "@mui/material/Stack";
import { NotificationTemplate, RECIPIENTS_SEND_METHODS, RECIPIENTS_COPY_METHODS } from "lib/schemas";
import { RadioFormInput } from "ui-widgets/forms";

type MultipleRecipientSettingsInputProps = Pick<
  NotificationTemplate,
  "multiple_recipients_send_method" | "multiple_recipients_copy_method"
> & {};
export const MultipleRecipientSettingsInput = ({
  multiple_recipients_send_method,
  multiple_recipients_copy_method,
}: MultipleRecipientSettingsInputProps) => {
  return (
    <Stack spacing={4}>
      <RadioFormInput<NotificationTemplate>
        schema_field_key="multiple_recipients_send_method"
        label="How should this notification be sent when it has multiple recipients?"
        value={multiple_recipients_send_method}
        options={RECIPIENTS_SEND_METHODS}
      />
      <RadioFormInput<NotificationTemplate>
        schema_field_key="multiple_recipients_copy_method"
        label="How should additional recipients be copied on this notification message?"
        value={multiple_recipients_copy_method}
        options={RECIPIENTS_COPY_METHODS}
      />
    </Stack>
  );
};
